import { isDevelopment } from './envHelper'
import { allDomains } from '../constants/siteList'

export const getCurrentSiteDomain = (currentSite) => {
  if (isDevelopment()) {
    return `${currentSite}.dev`
  } else {
    return `${currentSite}.net`
  }
}

export const isInSitesList = (host) => {
  return allDomains.indexOf(host) !== -1
}



// WEBPACK FOOTER //
// ./common/utils/sites.js